// Written in this round about way for babel-transform-imports
import Router from "react-router/es/Router";

export default Router;


// WEBPACK FOOTER //
// /codebuild/output/src2416834937/src/pobble-app/client/~/react-router-dom/es/Router.js